import Immutable from "immutable";

export default {
    SET: (state, action) => {
        let path = Array.isArray(action.payload.path)
            ? action.payload.path
            : action.payload.path.split(".");
        let pathState = action.payload && action.payload.path ? state.getIn(path) : {};

        if (!action.payload.toSet) {
            return state;
        }
        if (pathState) {
            //remove overwrite flag
            //We don't want to merge deep it does not work as expected for nested array values
            return state.setIn(path, pathState.merge(action.payload.toSet));
        } else {
            //we want to set a property, but the component initially was not declared with properties
            return state.setIn(path, Immutable.fromJS(action.payload.toSet));
        }
    },
    SET_MULTIPLE_DATA: (state, action) => {
        return state.withMutations(mutableState =>
            action.payload.forEach(entity => {
                mutableState.mergeIn(entity.path, entity.state);
            })
        );
    },
    MULTIPLE_SET: (state, action) => {
        let targets = action.payload.targets || [];
        let data = action.payload.data || {};

        return state.withMutations(state => {
            targets.forEach(path => {
                state.mergeIn(path, Immutable.fromJS(data));
            });
        });
    },
    SET_MULTIPLE_PROPERTIES: (state, action) => {
        let targets = action.payload.targets || [];
        let newProperties = action.payload.newProperties || {};

        return state.withMutations(state => {
            targets.forEach(path => {
                state.mergeIn([...path, "properties"], newProperties);
            });
        });
    },
    SET_PROPERTIES: (state, action) => {
        let payload = action.payload || [];

        return state.withMutations(state => {
            payload.forEach(item => {
                state.mergeIn([...item.path, "properties"], item.properties);
            });
        });
    },
    ADD_ENTITY: (state, action) => {
        let payload = action.payload || {};
        let targetPath = payload.target || [];
        let data = payload.data || {};
        let targetEntity = state.getIn(targetPath);
        let currentEntities = targetEntity.get("entities");
        //add new entity
        let newEntity = targetEntity.set("entities", currentEntities.push(Immutable.fromJS(data)));
        return state.setIn(targetPath, newEntity);
    },
    ADD_ENTITIES: (state, action) => {
        let payload = action.payload || {};
        let targetPaths = payload.targets || [];
        let data = payload.data || {};
        return state.withMutations(state => {
            targetPaths.forEach(targetPath => {
                let target = state.getIn(targetPath);
                let newEntity = target.withMutations(targetEntity => {
                    let currentEntities = targetEntity.get("entities");
                    //set actions data attribute
                    targetEntity.set("actions", data.actions || []);
                    //add new entities
                    targetEntity.set(
                        "entities",
                        currentEntities.concat(Immutable.fromJS(data.entities))
                    );
                });
                state.setIn(targetPath, newEntity);
            });
        });
    },
    REFRESH_TABLE_SUCCESS: (state, action) => {
        let path = action.payload.path;
        let data = Immutable.fromJS(action.payload.data);

        return state.setIn(path, data);
    },
    DATA_SET: (state, action) => {
        let targets = action.payload.targets || [];
        let data = action.payload.data || {};

        return state.withMutations(state => {
            targets.forEach(path => {
                state.setIn(path, Immutable.fromJS(data));
            });
        });
    },
    DATA_MERGE: (state, action) => {
        let targets = action.payload.targets || [];
        let data = action.payload.data || {};

        return state.withMutations(state => {
            targets.forEach(path => {
                state.mergeIn(path, Immutable.fromJS(data));
            });
        });
    }
};
